import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import { ParagraphTertiary, constants } from '@klarna/bubble-ui';

import FooterElement from './FooterElement';

const styles = {
  containerStyle: {
    display: 'flex',
    backgroundColor: constants.Colors.GRAY,
    padding: '12px 0',
    width: '100%',
    zIndex: 1,
    justifyContent: 'center',
  },
  horizontalAlignment: {
    alignItems: 'center',
  },
  verticalAlignment: {
    alignSelf: 'center',
  },
  itemWrapper: {
    width: 'fit-content',
  },
  paragraphStyle: {
    textTransform: 'uppercase',
  },
};

const Footer = ({ children, title = undefined }) => (
  <div style={styles.containerStyle}>
    <div style={styles.itemWrapper}>
      {title && (
        <FooterElement style={styles.paragraphStyle}>
          <ParagraphTertiary correctFootprint bold>
            {title}
          </ParagraphTertiary>
        </FooterElement>
      )}
      {children}
    </div>
  </div>
);

Footer.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Footer;
